module.exports = __webpack_public_path__ + "static/img/sj_cp.105da78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sj/sj_cp.png
// module id = 1kMh
// module chunks = 1